import React from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

/**
 * RegionModal component - displays a region selection modal
 */
const RegionModal = ({ sitecoreContext }) => {
  return (
    <div className="region-modal">
      <div className="modal-content">
        <h3>Select Region</h3>
        <div className="region-options">
          <button className="region-btn">North America</button>
          <button className="region-btn">Europe</button>
          <button className="region-btn">Asia Pacific</button>
          <button className="region-btn">Other</button>
        </div>
      </div>
    </div>
  );
};

export default withSitecoreContext()(RegionModal);
